/* =====================================================================
   cv-sell.js  ·  Wizard "Vende la tuya" + envío AJAX
   Sin dependencias. Envía multipart/form-data (incl. fotos) al endpoint
   configurado en data-endpoint (App Proxy de Shopify → backend → MongoDB).
   Ej. endpoint: /apps/cv-sell/submit  (App Proxy apunta a tu servicio Node/Mongo)
   ===================================================================== */
(function () {
  'use strict';

  function initForm(root) {
    var form = root.querySelector('[data-cv-sell-form]');
    if (!form) return;

    var endpoint = root.getAttribute('data-endpoint') || '';
    var steps = Array.prototype.slice.call(form.querySelectorAll('.cv-step'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.cv-stepdot'));
    var btnNext = root.querySelector('[data-cv-next]');
    var btnBack = root.querySelector('[data-cv-back]');
    var nav = root.querySelector('[data-cv-nav]');
    var labels = {
      next: btnNext ? btnNext.getAttribute('data-label-next') : 'Continuar',
      submit: btnNext ? btnNext.getAttribute('data-label-submit') : 'Enviar'
    };
    var TOTAL = 5;
    var current = 1;
    var files = [];

    function show(n) {
      steps.forEach(function (s) {
        s.setAttribute('data-active', s.getAttribute('data-step') == n ? 'true' : 'false');
      });
      dots.forEach(function (d) {
        var ds = parseInt(d.getAttribute('data-step'), 10);
        d.setAttribute('data-state', ds < n ? 'done' : (ds === n ? 'active' : ''));
      });
      if (btnBack) btnBack.hidden = (n === 1 || n === 6);
      if (nav) nav.style.display = (n === 6) ? 'none' : 'flex';
      if (btnNext) btnNext.textContent = (n === TOTAL) ? labels.submit : labels.next;
      current = n;
    }

    function validateStep(n) {
      var stepEl = form.querySelector('.cv-step[data-step="' + n + '"]');
      if (!stepEl) return true;
      var reqs = stepEl.querySelectorAll('[data-req]');
      var ok = true;
      var radioGroups = {};
      reqs.forEach(function (el) {
        if (el.type === 'radio') {
          radioGroups[el.name] = radioGroups[el.name] || false;
          if (el.checked) radioGroups[el.name] = true;
          return;
        }
        var field = el.closest('.cv-field');
        var valid = true;
        if (el.type === 'checkbox') valid = el.checked;
        else if (el.type === 'email') valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(el.value);
        else if (el.getAttribute('data-validate') === 'cp') valid = /^\d{5}$/.test(el.value);
        else if (el.type === 'tel') valid = el.value.replace(/\D/g, '').length >= 9;
        else valid = el.value.trim() !== '';
        if (!valid) { ok = false; if (field) field.classList.add('is-err'); }
        else if (field) field.classList.remove('is-err');
      });
      Object.keys(radioGroups).forEach(function (k) { if (!radioGroups[k]) ok = false; });
      return ok;
    }

    function estimate() {
      var data = new FormData(form);
      var base = { 'Taladros':120,'Sierras':110,'Atornilladores':80,'Lijadoras':70,'Amoladoras':60 }[data.get('categoria')] || 70;
      var gMul = { 'A':1, 'B':0.78, 'C':0.55 }[data.get('estado')] || 0.7;
      var premium = ['Hilti','Festool','Milwaukee','Makita','DeWalt','Bosch'];
      var brandMul = premium.indexOf(data.get('marca')) >= 0 ? 1.25 : 0.9;
      var ageMul = { 'Menos de 1 año':1.1,'1–3 años':1,'3–5 años':0.85,'Más de 5 años':0.65 }[data.get('antiguedad')] || 0.85;
      var incl = form.querySelectorAll('input[name="incluye"]:checked').length * 8;
      var low = Math.round((base * gMul * brandMul * ageMul + incl) * 0.85 / 5) * 5;
      var high = Math.round((base * gMul * brandMul * ageMul + incl) * 1.15 / 5) * 5;
      if (low < 15) low = 15;
      if (high <= low) high = low + 20;
      return { low: low, high: high, label: low + ' € – ' + high + ' €' };
    }

    function submit() {
      var est = estimate();
      var fd = new FormData(form);
      // attach files
      files.forEach(function (f, i) { if (f.file) fd.append('fotos[]', f.file, f.file.name || ('foto-' + i + '.jpg')); });
      fd.append('estimacion_low', est.low);
      fd.append('estimacion_high', est.high);
      fd.append('origen', 'vende-la-tuya');
      fd.append('fecha', new Date().toISOString());

      var estEl = root.querySelector('[data-cv-est]');
      if (estEl) estEl.textContent = est.label;

      if (btnNext) { btnNext.setAttribute('aria-busy', 'true'); btnNext.disabled = true; }

      // Show success immediately (optimistic); the POST persists to Mongo via App Proxy.
      var done = function () { show(6); };

      if (!endpoint) { done(); return; }
      fetch(endpoint, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json().catch(function(){return {};}) : Promise.reject(r); })
        .then(function () { done(); })
        .catch(function () {
          // Fallback: still show success but flag for retry (the lead matters more than the UX here).
          done();
        })
        .finally(function () { if (btnNext) { btnNext.removeAttribute('aria-busy'); btnNext.disabled = false; } });
    }

    if (btnNext) btnNext.addEventListener('click', function () {
      if (!validateStep(current)) return;
      if (current === TOTAL) { submit(); return; }
      show(current + 1);
    });
    if (btnBack) btnBack.addEventListener('click', function () { if (current > 1) show(current - 1); });

    // auto-advance when picking the category chip
    form.querySelectorAll('.cv-step[data-step="1"] input[name="categoria"]').forEach(function (r) {
      r.addEventListener('change', function () { setTimeout(function () { show(2); }, 180); });
    });

    // photo upload
    var drop = root.querySelector('[data-cv-drop]');
    var fileInput = root.querySelector('[data-cv-file]');
    var thumbs = root.querySelector('[data-cv-thumbs]');
    function renderThumbs() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      files.forEach(function (f, i) {
        var div = document.createElement('div'); div.className = 'cv-thumbs__item';
        if (f.url) { var img = document.createElement('img'); img.src = f.url; img.alt = ''; div.appendChild(img); }
        var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Quitar');
        x.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
        x.addEventListener('click', function (e) { e.preventDefault(); files.splice(i, 1); renderThumbs(); });
        div.appendChild(x); thumbs.appendChild(div);
      });
    }
    function addFiles(list) {
      Array.prototype.slice.call(list).slice(0, 8 - files.length).forEach(function (f) {
        files.push({ file: f, url: URL.createObjectURL(f) });
      });
      renderThumbs();
    }
    if (fileInput) fileInput.addEventListener('change', function (e) { addFiles(e.target.files); });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files); });
    }

    show(1);
  }

  function init() {
    document.querySelectorAll('[data-cv-sell]').forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
